/**
 * Created by tomers on 5/31/2015.
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("content-templates/content-gallery/system/contentSystemTabsLayout.tmpl");

    var SelectableCollectionDecorator = require("decorators/SelectableCollectionDecorator");
    var TabsBar = require("ui/tabsbar/TabsBar");
    var Button = require("ui/button/Button");
    var Paging = require("ui/paging/Paging");

    var ContentSystemTabsLayout = {};

    function moduleDefinition(LEContent, LE, Backbone, Marionette, $, _) {

        ContentSystemTabsLayout = Marionette.Layout.extend({
            className: "content-system-tabs-layout",
            template: template,
            ui: {
                tabsContainer: ".tabs-component-container",
                pagingContainer: ".paging-container",
                doneButton: ".button-done"
            },
            regions: {
                selectedTabRegion: ".selected-tab-container"
            },
            uiComponents: {
                paging: {
                    type: Paging,
                    options: {
                        el: "view.ui.pagingContainer",
                        collection: "view._getGalleryCollection",
                        blockWrongPageNumber: true,
                        showClearSelection: false
                    },
                    events: {
                        "change:page": "_changePage",
                        "clearSelection": "_clearSelection"
                    }
                },
                doneBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.doneButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_done"
                    }
                }
            },

            initialize: function(options) {
                this._initialize(options);
            },

            onRender: function() {
                this._onRender();
            },

            setSelectedTab: function(tabId) {
                this._setSelectedTab(tabId);
            },
            setPageModel: function(tablePageModel){
                this._initPageModel(tablePageModel);
            },
            onClose: function() {
                LEContent.logger.debug("closing", "ContentSystemTabsLayout:close");
            },

            _initialize: function(options) {
                this.channel = options.channel;
                this.tabsCollection = this._getTabsCollection(options.tabs);
                this.tablePageModel = options.tablePageModel;
                this._setSelectedTab(options.selectedTab);
            },

            _onRender: function() {
                var shouldRenderTabs = LE.sessionManager.hasMessagingAutoMessagesFeature() && !LE.siteSettings.accountSettings.hideChatOptions();
                if (shouldRenderTabs) {
                    this.uiComponents.host$.createAndRender("tabs", {
                        type: TabsBar,
                        options: {
                            el: "view.ui.tabsContainer",
                            permutation: TabsBar.PERMUTATION.C,
                            commitStateChange: false,
                            collection: "view.tabsCollection"
                        },
                        events: {
                            "change:selection": "_onHeaderTabsChange",
                            "click:tabButton": "_addButtonClicked"
                        }
                    });
                    this.$el.addClass("content-system-tabs");
                }

                this._initPageModel(this.tablePageModel);
                this.listenTo(this, "page:closeButtonClick", this._onCloseButtonClick);
                // this.listenTo(this.uiComponents.paging, "clearSelection", this._clearSelection);
            },

            _initPageModel: function(tablePageModel) {
                if (this.tablePageModel){
                    this.stopListening(this.tablePageModel);
                }
                this.tablePageModel = tablePageModel;

                if (this.tablePageModel) {
                    this.uiComponents.paging.setCollection(this.tablePageModel.getOrganizedCollection());
                    this.listenTo(this.tablePageModel, "change:pageInfo.*", this._updatePagingComponent);
                }

            },

            _getGalleryCollection: function () {
                return this.tablePageModel.getOrganizedCollection();
            },

            _updatePagingComponent: function(){
                this.uiComponents.paging.setInfo(this.tablePageModel.getContentPageInfoCurrentPage(),this.tablePageModel.getContentPageInfoTotal());
            },

            _clearSelection: function () {
                this.channel.trigger("paging:clear:AllSelection");
            },

            _setSelectedTab: function(tabId) {
                this.tabsCollection.selectModel(tabId);
            },

            _getTabsCollection: function(tabs){
                var tabsCollection = new TabsBar.TabCollection(tabs);
                return SelectableCollectionDecorator.decorate(tabsCollection);
            },

            _onHeaderTabsChange: function(componentName, eventName, selectedTabId) {
                this.channel.trigger("contentSystemTabs:tab:change", selectedTabId);
            },

            _done: function () {
                LEContent.logger.info("User clicked on 'done' button.", "ContentSystemTableLayout::_done");
                this.channel.trigger("contentSystemTabs:buttons:done");
            },

            _changePage: function (component,event,idx) {
                LEContent.logger.info("User asks to change page to " + idx, "ContentSystemTableLayout::_changePage");
                this.channel.trigger("contentSystemTabs:change:page",idx);
            },

            _onCloseButtonClick: function() {
                this.channel.trigger("contentSystemTabs:page:close");
            }
        });

    }

    LE.module("LEContent", moduleDefinition);


    return ContentSystemTabsLayout;
});
